/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod_IntroInputs */

const es_landing_mod_intro = /** @type {(inputs: Landing_Mod_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sea cual sea tu barco y como quieras usarlo, la misma filosofía: tarifa plana, sin fricción y más días en el agua.`)
};

const gl_landing_mod_intro = /** @type {(inputs: Landing_Mod_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sexa cal sexa o teu barco e como o queiras usar, a mesma filosofía: tarifa plana, sen fricción e máis días na auga.`)
};

const en_landing_mod_intro = /** @type {(inputs: Landing_Mod_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whatever your boat and how you use it, the same idea: flat fee, no friction, more days on the water.`)
};

/**
* | output |
* | --- |
* | "Whatever your boat and how you use it, the same idea: flat fee, no friction, more days on the water." |
*
* @param {Landing_Mod_IntroInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod_intro = /** @type {((inputs?: Landing_Mod_IntroInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod_IntroInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod_intro(inputs)
	if (locale === "en") return en_landing_mod_intro(inputs)
	return es_landing_mod_intro(inputs)
});